import { useEffect } from 'react'
import { useFeatureFlagContext } from 'utils/context/FeatureFlagsContext'
import { useCarrierMembershipApi } from './useCarrierMembershipApi'
import { useTeamMembersApi } from './useTeamMembersApi'

export const useMembership = () => {
  const carrierMembershipApi = useCarrierMembershipApi()
  const teamMembersApi = useTeamMembersApi()
  const { getFlag } = useFeatureFlagContext()
  const { enabled: isFpCarrierPortalEnabled } = getFlag('fpCarrierPortal')

  /**
   * Fetch this data on mount
   */
  useEffect(() => {
    if (!isFpCarrierPortalEnabled) return
    teamMembersApi.getTeamMembers()
    carrierMembershipApi.getUserMotorCarriers()
    carrierMembershipApi.fetchMotorCarrierUsers()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFpCarrierPortalEnabled])

  return {
    ...carrierMembershipApi,
    ...teamMembersApi,
  }
}
